import { Drawer } from '@mui/material'
import React from 'react'
import { ArrowLeftIcon } from '@heroicons/react/solid'
import useReadWithGet from '../../hooks/read/useReadWithGetMethod'
import Moment from 'react-moment'
import RoundedContainer from '../../components/containers/RoundedContainer'
import {
  Table,
  TableHead,
  TableHeaderCell,
  TableBody,
  TableRow,
  TableCell,
} from '../../components/table/Table'
import toast from 'react-hot-toast'

const SingleResignEmployeeDetail = ({ open, handleCloseDialog, userId }) => {
    const { list: employeeData } = useReadWithGet({
        url: 'getSingleUserResignationDetails',
        initialData: {
            company_employee_id: userId
        },
        onError: (err) => {
            toast.error(err?.response?.data?.message || "Failed to fetch employee details")
        }
    })
    const emp = employeeData.data?.data || {};
    return (
        <Drawer anchor={'right'} open={open} onClose={handleCloseDialog}>
            <div className='h-full bg-white' style={{ width: 'calc(100vw - 650px)' }}>
                <div className='border-b border-gray-200 px-8 sticky top-0 bg-white flex items-center justify-between'>
                    <div className=' flex items-center space-x-4'>
                        <ArrowLeftIcon className='w-6 h-6 text-black cursor-pointer' onClick={handleCloseDialog} />
                        <h1 className=' text-3xl font-semibold py-3'>User Details</h1>
                    </div>
                </div>
                <div className='px-8 mt-10'>
                    <div className='grid grid-cols-1 gap-5'>
                        <RoundedContainer>
                          <Table>
                            <TableHead>
                              <TableHeaderCell colSpan={2} className='font-bold text-base text-center'>
                                Employee Details
                              </TableHeaderCell>
                            </TableHead>
                            <TableBody>
                              <TableRow>
                                <TableCell className='font-bold'>First Name</TableCell>
                                <TableCell>{emp.first_name}</TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell className='font-bold'>Last Name</TableCell>
                                <TableCell>{emp.last_name}</TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell className='font-bold'>Email</TableCell>
                                <TableCell>{emp.email}</TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell className='font-bold'>Date Of Birth</TableCell>
                                <TableCell>
                                  <Moment format='LL'>
                                    {emp.date_of_birth}
                                  </Moment>
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell className='font-bold'>Mobile Number</TableCell>
                                <TableCell>{emp.phone}</TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell className='font-bold'>Alternate Number</TableCell>
                                <TableCell>{emp.alternate_number}</TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell className='font-bold'>Date of joining</TableCell>
                                <TableCell>
                                  <Moment unix format='LL'>
                                    {emp.date_of_joining}
                                  </Moment>
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell className='font-bold'>Date of leaving</TableCell>
                                <TableCell>
                                  <Moment unix format='LL'>
                                    {emp.date_of_leaving}
                                  </Moment>
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </RoundedContainer>
                    </div>
                    {emp.remarks && 
                    <div className='mt-4'>
                        <label className=' roboto label'>Remark</label>
                        <p>{emp.remarks}</p>
                    </div>}
                    {emp.document && 
                    <div className='mt-10'>
                        <h1 className='font-bold rounded-t-lg py-3 px-4 bg-gray-200 text-primary text-center'>Document</h1>
                        <img src={emp.document} alt="doc" className="rounded-b-lg border border-gray-200" />
                    </div>}
                </div>
            </div>
        </Drawer>
    )
}

export default SingleResignEmployeeDetail